import { contactSchema, CONTACT_MAX_COMMENTS, type ContactInput } from "@biosany/shared"
import { api } from "@/lib/api"

/** Máximo de caracteres del campo de comentarios (UI). */
export const MAX_COMMENTS = CONTACT_MAX_COMMENTS

/** Cooldown tras enviar (5 min) antes de volver a mostrar el formulario. */
export const CONTACT_COOLDOWN_MS = 5 * 60 * 1000

/** Clave de localStorage con el timestamp (ms) del último envío. */
export const CONTACT_SENT_KEY = "biosany:contact:lastSent"

/** Schema de los campos del formulario (sin `treatment`, que viene de la ruta). */
export const contactFormFieldsSchema = contactSchema.omit({ treatment: true })

export type ContactFormValues = Omit<ContactInput, "treatment">

/**
 * Envía el formulario vía API (el webhook de Make vive solo en el backend).
 */
export async function submitContactForm(values: ContactFormValues, treatment: string): Promise<void> {
	await api.submitContact({ ...values, treatment })
}
